import { createSlice } from '@reduxjs/toolkit';
import type { UserAffiliationType } from '../../services/api/userAffiliationTypeService';
import {
  loadUserAffiliationTypes,
  createUserAffiliationType,
  updateUserAffiliationType,
  deleteUserAffiliationType,
} from '../thunks/userAffiliationTypeThunks';

export interface UserAffiliationTypeState {
  items: UserAffiliationType[];
  status: 'idle' | 'loading' | 'success' | 'failure';
  lastError: string | null;
}

const initialState: UserAffiliationTypeState = {
  items: [],
  status: 'idle',
  lastError: null,
};

const userAffiliationTypeSlice = createSlice({
  name: 'userAffiliationType',
  initialState,
  reducers: {
    clearError(state) {
      state.lastError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadUserAffiliationTypes.pending, (state) => {
        state.status = 'loading';
        state.lastError = null;
      })
      .addCase(loadUserAffiliationTypes.fulfilled, (state, action) => {
        state.status = 'success';
        state.items = action.payload.items;
      })
      .addCase(loadUserAffiliationTypes.rejected, (state, action) => {
        state.status = 'failure';
        state.lastError = (action.payload as string) ?? action.error.message ?? 'Failed to load affiliation types';
      });

    builder
      .addCase(createUserAffiliationType.fulfilled, (state) => {
        state.lastError = null;
      })
      .addCase(updateUserAffiliationType.fulfilled, (state) => {
        state.lastError = null;
      })
      .addCase(deleteUserAffiliationType.fulfilled, (state, action) => {
        state.lastError = null;
        state.items = state.items.filter((x) => x.id !== action.payload.affiliationTypeId);
      });
  },
});

export const { clearError } = userAffiliationTypeSlice.actions;
export default userAffiliationTypeSlice.reducer;
